import * as React from 'react'
import {
  Datagrid,
  List,
  Create,
  Edit,
  TextField,
  TextInput,
  SimpleForm,
  SelectInput,
  Show,
  SelectField,
  SimpleShowLayout,
  FunctionField,
  usePermissions,
  Filter,
} from 'react-admin'
import {
  ArchivedSelect,
  CoursesField,
  CoursesSelect,
} from '../components/selects'
import { ArchivalToolbar } from '../components/ArchivalToolbar'

const ListBase = (props) => {
  const { permissions } = usePermissions()

  return (
    <List
      exporter={permissions?.includes('admin') ? undefined : false}
      sort={{ field: 'email', order: 'ASC' }}
      filters={<UserFilter />}
      perPage={25}
      {...props}
    >
      <UserList {...props} />
    </List>
  )
}

const ShowBase = (props) => (
  <Show {...props}>
    <UserShow />
  </Show>
)

const CreateBase = (props) => (
  <Create {...props}>
    <UserForm />
  </Create>
)

const EditBase = (props) => (
  <Edit undoable={false} {...props}>
    <UserForm />
  </Edit>
)

export const list = ListBase
export const edit = EditBase
export const show = ShowBase
export const create = CreateBase

const UserFilter = (props) => (
  <Filter style={{ margin: 10 }} {...props}>
    <ArchivedSelect />
  </Filter>
)

const UserList = (props) => (
  <Datagrid
    rowClick={props.permissions?.includes('admin') ? 'edit' : 'show'}
    {...props}
  >
    <TextField source="email" />
    <TextField source="first_name" />
    <TextField source="last_name" />
    <TextField source="type" />
  </Datagrid>
)

const UserShow = (props) => (
  <SimpleShowLayout {...props}>
    <FunctionField
      label="Name"
      render={(s) =>
        s ? `${s.first_name} ${s.middle_initial || 'X'} ${s.last_name}` : ''
      }
    />
    <TextField fullWidth source="email" />
    <SelectField
      fullWidth
      defaultValue="instructor"
      source="type"
      choices={ROLES}
    />
    <CoursesField />
  </SimpleShowLayout>
)

const UserForm = (props) => {
  const { permissions } = usePermissions()
  const isAdmin = permissions ? permissions.includes('admin') : false
  return (
    <SimpleForm
      toolbar={<ArchivalToolbar isAdmin={isAdmin} />}
      warnWhenUnsavedChanges
      {...props}
    >
      <TextInput disabled={!isAdmin} fullWidth source="email" />
      <TextInput disabled={!isAdmin} fullWidth source="sk" />

      <div fullWidth className="flex-inputs">
        <TextInput disabled={!isAdmin} source="first_name" />
        <TextInput disabled={!isAdmin} source="middle_initial" />
        <TextInput disabled={!isAdmin} source="last_name" />
      </div>

      <SelectInput
        fullWidth
        disabled={!isAdmin}
        defaultValue="instructor"
        source="type"
        choices={ROLES}
      />
      <CoursesSelect />
    </SimpleForm>
  )
}

const ROLES = [
  { id: 'instructor', name: 'Instructor' },
  { id: 'director', name: 'Course Director' },
  { id: 'admin', name: 'Admin' },
]
